import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../core/api.service';
import { Alert } from '../../core/models';

@Component({
  selector: 'app-alerts',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alerts.component.html',
  styleUrl: './alerts.component.scss',
})
export class AlertsComponent implements OnInit {
  private api = inject(ApiService);
  alerts = signal<Alert[]>([]);
  message = signal('');

  ngOnInit(): void {
    this.reload();
  }

  reload(): void {
    this.api.get<Alert[]>('/api/dashboard/alerts').subscribe((a) => this.alerts.set(a));
  }

  runNow(): void {
    this.api.post<{ created: number }>('/api/dashboard/alerts/run').subscribe((r) => {
      this.message.set(`Controllo eseguito: ${r.created} nuovi alert`);
      this.reload();
    });
  }
}
